import { CoreInitiativesLinksName } from './name';
import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getInitiativeLinks } from '@api';

export const coreInitiativesLinksGetAsyncSlice = createGetAsyncSlice({
	name: CoreInitiativesLinksName,
	receive: true,
	request: true,
	requestHandler: getInitiativeLinks,
	retainDataOnRequest: true
});
